const pagesPeopleSettingsEn = {
  boardMemberTypes: {
    addBoardMemberType: 'Add board member type',
    description: 'A classification that indicates the type of board member, and includes different types such as executive, non-executive, and external director.',
    editBoardMemberType: 'Edit {{name}}',
    form: {
      code: {
        description: 'Code must be unique in your organization.',
        label: 'Code',
        placeholder: 'executive, auditor'
      },
      displayOrder: {
        description: {
          forAdd: 'If you do not input display order, default value 0 will be set.'
        },
        label: 'Display order',
        placeholder: '1'
      },
      name: {
        description: 'Name should be unique in your organization.',
        label: 'Name',
        placeholder: 'executive, auditor'
      }
    },
    searchPlaceholder: 'Filter by name, code...',
    showDeactivated: 'Show only deactivated',
    title: 'Board member type'
  },
  collaboratorTypes: {
    addCollaboratorType: 'Add collaborator type',
    description: 'Outside collaborators are individuals and corporations that are not employees or contractors of the organization. They can be used to customer representatives or something like that.',
    editCollaboratorType: 'Edit {{name}}',
    form: {
      code: {
        description: 'Code must be unique in your organization.',
        label: 'Code',
        placeholder: 'C01, C02'
      },
      displayOrder: {
        description: {
          forAdd: 'If you do not input display order, default value 0 will be set.'
        },
        label: 'Display order',
        placeholder: '1'
      },
      name: {
        description: 'Name should be unique in your organization.',
        label: 'Name',
        placeholder: 'Customer Representative, Head Office Representative'
      }
    },
    searchPlaceholder: 'Filter by name, code...',
    showDeactivated: 'Show only deactivated',
    title: 'Collaborator type'
  },
  contractEndReasons: {
    addContractEndReason: 'Add contract end reason',
    description: "A contract end reason indicates why a contractor's contract is ending. For example, project completion or personal request.",
    editContractEndReason: 'Edit {{name}}',
    form: {
      displayOrder: {
        description: {
          forAdd: 'If you do not input display order, default value 0 will be set.'
        },
        label: 'Display order',
        placeholder: '1'
      },
      name: {
        description: 'Name should be unique in your organization.',
        label: 'Name',
        placeholder: 'Project end'
      }
    },
    searchPlaceholder: 'Filter by name...',
    showDeactivated: 'Show only deactivated',
    title: 'Contract end reason'
  },
  contractorTypes: {
    addContractorType: 'Add contractor type',
    description: 'A classification of individuals and corporations that perform work based on contracts with companies, and includes different types such as directors, outsourcers, external consultants, and outsourcers. ',
    editContractorType: 'Edit {{name}}',
    form: {
      code: {
        description: 'Code must be unique in your organization.',
        label: 'Code',
        placeholder: 'director, partner, temporary'
      },
      displayOrder: {
        description: {
          forAdd: 'If you do not input display order, default value 0 will be set.'
        },
        label: 'Display order',
        placeholder: '1'
      },
      name: {
        description: 'Name should be unique in your organization.',
        label: 'Name',
        placeholder: 'Director, Partner, Temporary'
      }
    },
    searchPlaceholder: 'Filter by name, code...',
    showDeactivated: 'Show only deactivated',
    title: 'Contractor type'
  },
  employeeSubIdNames: {
    addEmployeeSubIdName: 'Add Employee Sub ID',
    description: 'The Employee Sub ID is used for identification, for example, in cases where a different ID is assigned at a subsidiary.',
    editEmployeeSubIdName: 'Edit {{name}}',
    form: {
      displayOrder: {
        description: {
          forAdd: 'If you do not enter a display order, the default value 0 will be set.'
        },
        label: 'Display Order',
        placeholder: '1'
      },
      name: {
        description: 'The name must be unique within the organization.',
        label: 'Name',
        placeholder: 'Partner Code'
      }
    },
    searchPlaceholder: 'Search by name',
    showDeactivated: 'Show Deactivated Only',
    title: 'Employee Sub ID'
  },
  employmentTypes: {
    addEmploymentType: 'Add employment type',
    description: "A classification that indicates the type of employee's labor contract and work style, and includes different employment forms such as full-time, part-time, contract employee, and part-time job.",
    editEmploymentType: 'Edit {{name}}',
    form: {
      code: {
        description: 'Code must be unique in your organization.',
        label: 'Code',
        placeholder: 'full-time, part-time'
      },
      displayOrder: {
        description: {
          forAdd: 'If you do not input display order, default value 0 will be set.'
        },
        label: 'Display order',
        placeholder: '1'
      },
      name: {
        description: 'Name should be unique in your organization.',
        label: 'Name',
        placeholder: 'Full-time, Part-time'
      }
    },
    searchPlaceholder: 'Filter by name, code...',
    showDeactivated: 'Show only deactivated',
    title: 'Employment type'
  },
  grades: {
    addGrade: 'Add grade',
    description: 'A classification that indicates a hierarchy based on the evaluation and role of each employee. It can be used to express salary ranges, etc.',
    editGrade: 'Edit {{name}}',
    form: {
      code: {
        description: 'Code must be unique in your organization.',
        label: 'Code',
        placeholder: 'a1, b3, c2'
      },
      displayOrder: {
        description: {
          forAdd: 'If you do not input display order, default value 0 will be set.'
        },
        label: 'Display order',
        placeholder: '1'
      },
      name: {
        description: 'Name should be unique in your organization.',
        label: 'Name',
        placeholder: 'A1, B3, C2'
      },
      rank: {
        description: 'Rank represents the hierarchical relationship between grades.',
        helpText: 'Rank can be used as a condition for various rules, such as app assignment rule.',
        label: 'Rank',
        placeholder: '1'
      }
    },
    searchPlaceholder: 'Filter by name, code...',
    showDeactivated: 'Show only deactivated',
    title: 'Grade'
  },
  healthInsuranceAssociations: {
    addHealthInsuranceAssociation: 'Add health insurance association',
    description: 'A classification of health insurance associations that employees join, including different insurance organizations such as the National Health Insurance Association and health insurance unions.',
    dialog: {
      addTitle: 'Add health insurance association',
      editTitle: 'Edit health insurance association',
      form: {
        associationName: 'Health insurance society name',
        associationNamePlaceholder: 'National Health Insurance Association, Health Insurance Union',
        associationType: 'Health insurance society type',
        associationTypePlaceholder: 'National Health Insurance Association, Health Insurance Union'
      }
    },
    editHealthInsuranceAssociation: 'Edit {{name}}',
    title: 'Health Insurance Association'
  },
  jobCompetencies: {
    addJobCompetency: 'Add job competency',
    description: 'Employee A grade that is set based on the skills and abilities an employee possesses. Job competency can be used to evaluate skill levels and job performance, and to express promotions and career paths.',
    editJobCompetency: 'Edit {{name}}',
    form: {
      code: {
        description: 'Code must be unique in your organization.',
        label: 'Code',
        placeholder: 'management, general'
      },
      displayOrder: {
        description: {
          forAdd: 'If you do not input display order, default value 0 will be set.'
        },
        label: 'Display order',
        placeholder: '1'
      },
      name: {
        description: 'Name should be unique in your organization.',
        label: 'Name',
        placeholder: 'Management, General'
      },
      rank: {
        description: 'Rank represents the hierarchical relationship between job competencies.',
        helpText: 'Rank can be used as a condition for various rules, such as app assignment rule.',
        label: 'Rank',
        placeholder: '1'
      }
    },
    searchPlaceholder: 'Filter by name, code...',
    showDeactivated: 'Show only deactivated',
    title: 'Job competency'
  },
  jobFunctions: {
    addJobFunction: 'Add job function',
    description: 'This is a classification that indicates more detailed work content and task content that cannot be expressed by job title alone. Jobs specify the roles and scope of responsibilities within a job category, and can be used as indicators of work results and goal achievement.',
    editJobFunction: 'Edit {{name}}',
    form: {
      code: {
        description: 'Code must be unique in your organization.',
        label: 'Code',
        placeholder: 'backend-engineer'
      },
      displayOrder: {
        description: {
          forAdd: 'If you do not input display order, default value 0 will be set.'
        },
        label: 'Display order',
        placeholder: '1'
      },
      jobType: {
        label: 'Job type',
        placeholder: 'Select job type...',
        searchPlaceholder: 'Search job type...'
      },
      name: {
        description: 'Name should be unique in your organization.',
        label: 'Name',
        placeholder: 'Backend engineer'
      }
    },
    searchPlaceholder: 'Filter by name, code...',
    showDeactivated: 'Show only deactivated',
    title: 'Job function'
  },
  jobGrades: {
    addJobGrade: 'Add job grade',
    description: 'This is a grade that is set according to the job content and responsibility of employees and contractors. Job grades are classified based on job title and scope of work, and can be used for purposes such as clarifying roles and their values within an organization.',
    editJobGrade: 'Edit {{name}}',
    form: {
      code: {
        description: 'Code must be unique in your organization.',
        label: 'Code',
        placeholder: 'manager1, senior3'
      },
      displayOrder: {
        description: {
          forAdd: 'If you do not input display order, default value 0 will be set.'
        },
        label: 'Display order',
        placeholder: '1'
      },
      name: {
        description: 'Name should be unique in your organization.',
        label: 'Name',
        placeholder: 'Manager 1, Senior 3'
      },
      rank: {
        description: 'Rank represents the hierarchical relationship between job grades.',
        helpText: 'Rank can be used as a condition for various rules, such as app assignment rule.',
        label: 'Rank',
        placeholder: '1'
      }
    },
    searchPlaceholder: 'Filter by name, code...',
    showDeactivated: 'Show only deactivated',
    title: 'Job grade'
  },
  jobLevels: {
    addJobLevel: 'Add job level',
    description: "Job level refers to the hierarchical ranking of a specific job within an organization, indicating its scope, level of responsibility, and required expertise to earn. While often related to organizational structure and titles, it's not always a direct match.",
    editJobLevel: 'Edit {{name}}',
    form: {
      code: {
        description: 'Code must be unique in your organization.',
        label: 'Code',
        placeholder: 'senior'
      },
      displayOrder: {
        description: {
          forAdd: 'If you do not input display order, default value 0 will be set.'
        },
        label: 'Display order',
        placeholder: '1'
      },
      name: {
        description: 'Name should be unique in your organization.',
        label: 'Name',
        placeholder: 'Senior (engineer)'
      }
    },
    searchPlaceholder: 'Filter by name, code...',
    showDeactivated: 'Show only deactivated',
    title: 'Job level'
  },
  jobTitles: {
    addJobTitle: 'Add job title',
    description: "A classification that indicates an employee's position or position, and includes different positions such as general manager, section manager, supervisor, and staff. ",
    editJobTitle: 'Edit {{name}}',
    form: {
      code: {
        description: 'Code must be unique in your organization.',
        label: 'Code',
        placeholder: 'manager'
      },
      displayOrder: {
        description: {
          forAdd: 'If you do not input display order, default value 0 will be set.'
        },
        label: 'Display order',
        placeholder: '1'
      },
      name: {
        description: 'Name should be unique in your organization.',
        label: 'Name',
        placeholder: 'Manager'
      },
      rank: {
        description: 'Rank represents the hierarchical relationship between job titles.',
        helpText: 'Rank can be used as a condition for various rules, such as app assignment rule.',
        label: 'Rank',
        placeholder: '1'
      }
    },
    searchPlaceholder: 'Filter by name, code...',
    showDeactivated: 'Show only deactivated',
    title: 'Job title'
  },
  jobTypes: {
    addJobType: 'Add job type',
    description: 'A classification that indicates the field or specialty of an employee or contractor, with each job category representing a specific skill set or knowledge. By registering sales positions, development positions, etc., you can use them for conditions of various rules.',
    editJobType: 'Edit {{name}}',
    form: {
      code: {
        description: 'Code must be unique in your organization.',
        label: 'Code',
        placeholder: 'sales, engineer'
      },
      displayOrder: {
        description: {
          forAdd: 'If you do not input display order, default value 0 will be set.'
        },
        label: 'Display order',
        placeholder: '1'
      },
      name: {
        description: 'Name should be unique in your organization.',
        label: 'Name',
        placeholder: 'Sales, Engineer'
      }
    },
    searchPlaceholder: 'Filter by name, code...',
    showDeactivated: 'Show only deactivated',
    title: 'Job type'
  },
  placeSocialInsurances: {
    actions: {
      delete: 'Delete',
      openMenu: 'Open menu',
      viewDetails: 'View Details'
    },
    addPlaceSocialInsurance: 'Add Business Establishment',
    columns: {
      address: 'Address',
      businessEstablishment: 'Business Establishment',
      representative: 'Representative'
    },
    description: 'Manage social insurance business establishments.',
    dialog: {
      add: 'Add',
      cancel: 'Cancel',
      cannotSelectPlaceDescription: "To register a new place, please click the 'Proceed to Add Place' button below.",
      cannotSelectPlaceTitle: 'No places available',
      loadingPlaces: 'Loading places...',
      proceedToAddPlace: 'Proceed to Add Place',
      searchPlaceName: 'Search Place Name',
      selectPlace: 'Select Place',
      selectPlaceDescription: 'Select a place to add as a social insurance business establishment',
      selectPlaceError: 'Please select a place.',
      selectPlaceLabel: 'Place',
      selectPlaceTitle: 'Select Place'
    },
    title: 'Business Establishments'
  },
  positions: {
    addPosition: 'Add position',
    description: 'This is a classification that indicates the job content and scope of responsibilities of employees and executives. Job titles can be expressed by department, or by positions such as CEO or CTO that are not tied to a department.',
    editPosition: 'Edit {{name}}',
    form: {
      code: {
        description: 'Code must be unique in your organization.',
        label: 'Code',
        placeholder: 'ceo, mgr'
      },
      displayOrder: {
        description: {
          forAdd: 'If you do not input display order, default value 0 will be set.'
        },
        label: 'Display order',
        placeholder: '1'
      },
      name: {
        description: 'Name should be unique in your organization.',
        label: 'Name',
        placeholder: 'CEO, Manager'
      },
      rank: {
        description: 'Rank represents the hierarchical relationship between positions.',
        helpText: 'Rank can be used as a condition for various rules, such as app assignment rule.',
        label: 'Rank',
        placeholder: '1'
      }
    },
    searchPlaceholder: 'Filter by name, code...',
    showDeactivated: 'Show only deactivated',
    title: 'Position'
  },
  retirementReasons: {
    addRetirementReason: 'Add retirement reason',
    description: 'A retirement reason indicates why an employee is retiring. For example, mandatory retirement or voluntary resignation.',
    editRetirementReason: 'Edit {{name}}',
    form: {
      displayOrder: {
        description: {
          forAdd: 'If you do not input display order, default value 0 will be set.'
        },
        label: 'Display order',
        placeholder: '1'
      },
      name: {
        description: 'Name should be unique in your organization.',
        label: 'Name',
        placeholder: 'Mandatory retirement'
      }
    },
    searchPlaceholder: 'Filter by name...',
    showDeactivated: 'Show only deactivated',
    title: 'Retirement reason'
  },
  shared: {
    DeleteDialog: {
      cancelButton: 'Cancel',
      description: 'If you use {{name}}, you cannot delete master name. This operation cannot be undone.',
      permanentlyDeleteButton: 'Permanently Delete',
      title: 'Delete {{name}}?'
    },
    DisableDialog: {
      cancelButton: 'Cancel',
      description: 'If you deactivate {{name}}, you will not use it anymore. The data will not be deleted and can view it in past data. You can activate it again.',
      disableButton: 'Deactivate',
      title: 'Deactivate {{name}}?'
    },
    EnableDialog: {
      cancelButton: 'Cancel',
      description: 'If you activate {{name}}, you can use it again. The previously deactivated data will be restored to active status and available for use.',
      enableButton: 'Activate',
      title: 'Activate {{name}}?'
    },
    actionsColumn: {
      deleteButton: 'Delete',
      disableButton: 'Deactivate',
      enableButton: 'Activate'
    },
    editDisplayOrder: 'Edit display order'
  },
  workModes: {
    addWorkMode: 'Add work mode',
    description: 'Work arrangement refers to the terms and conditions under which an employee and contractor performs their job: for example, full-time, flextime, part-time and etc.',
    editWorkMode: 'Edit {{name}}',
    form: {
      code: {
        description: 'Code must be unique in your organization.',
        label: 'Code',
        placeholder: 'full-time, part-time'
      },
      displayOrder: {
        description: {
          forAdd: 'If you do not input display order, default value 0 will be set.'
        },
        label: 'Display order',
        placeholder: '1'
      },
      name: {
        description: 'Name should be unique in your organization.',
        label: 'Name',
        placeholder: 'Full-time, Part-time'
      }
    },
    searchPlaceholder: 'Filter by name, code...',
    showDeactivated: 'Show only deactivated',
    title: 'Work mode'
  }
};
export default pagesPeopleSettingsEn;